export default __webpack_public_path__ + "static/media/pig_game.78efca78.png";